import React from "react";

export const LegitScriptSeal = () => {
  const [isLoaded, setIsLoaded] = React.useState(false);

  const handleLoad = (e: React.SyntheticEvent<HTMLIFrameElement>) => {
    const target = e.target as HTMLIFrameElement;
    const body = target.contentWindow?.document.body;

    if (!body) return;

    body.style.margin = "0";
    body.style.overflow = "hidden";

    const img = body.getElementsByTagName("img")[0];

    if (img) {
      img.src = img.src.replace("about://", "http://");
      setIsLoaded(true);
    }
  };

  return (
    <iframe
      style={{
        opacity: isLoaded ? 1 : 0,
        transition: "opacity 0.5s ease-in",
        width: "140px",
        height: "120px",
      }}
      onLoad={handleLoad}
      title="LegitScriptSeal"
      srcDoc='<script src="https://static.legitscript.com/seals/17996912.js"></script>'
    />
  );
};
